import React, { useState } from 'react';
import { Container, Row, Col, Modal } from 'react-bootstrap';
import './Gallery.css';

const Gallery = () => {
    const [showModal, setShowModal] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);

    const galleryImages = [
        {
            src: 'https://images.unsplash.com/photo-1606811841689-23dfddce3e95?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
            title: 'Salle de consultation moderne',
            category: 'Équipements'
        },
        {
            src: 'https://images.unsplash.com/photo-1551601651-2a8555f1a136?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
            title: 'Cabinet d\'orthodontie',
            category: 'Équipements'
        },
        {
            src: 'https://dr-ohana-chpindel-florence.chirurgiens-dentistes.fr/wp-content/uploads/2015/11/1.png',
            title: 'Sourire éclatant après traitement',
            category: 'Résultats'
        },
        {
            src: 'https://media.gettyimages.com/id/647724570/fr/photo/outils-de-dentiste-%C3%A9quipement.jpg?s=612x612&w=gi&k=20&c=3IbAdYXaiXB1d3NCYJvQvonz_EhV_3MAPQXxZJmCz3Q=',
            title: 'Technologie de pointe',
            category: 'Équipements'
        },
        {
            src: 'https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
            title: 'Transformation orthodontique',
            category: 'Résultats'
        },
        {
            src: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
            title: 'Blanchiment professionnel',
            category: 'Résultats'
        }
    ];

    const openModal = (image) => {
        setSelectedImage(image);
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
        setSelectedImage(null);
    };

    return (
        <section id="gallery" className="gallery-section">
            <Container>
                <Row>
                    <Col lg={8} className="mx-auto text-center">
                        <div className="section-header">
                            <span className="section-badge">Galerie</span>
                            <h2 className="section-title">
                                Découvrez notre environnement et nos résultats
                            </h2>
                            <p className="section-subtitle">
                                Visitez virtuellement notre cabinet moderne et découvrez les transformations 
                                réalisées pour nos patients.
                            </p>
                        </div>
                    </Col>
                </Row>

                <Row className="g-4">
                    {galleryImages.map((image, index) => (
                        <Col lg={4} md={6} key={index}>
                            <div 
                                className="gallery-item"
                                onClick={() => openModal(image)}
                            >
                                <img 
                                    src={image.src} 
                                    alt={image.title}
                                    className="gallery-image"
                                />
                                <div className="gallery-overlay">
                                    <div className="gallery-content">
                                        <span className="gallery-category">{image.category}</span>
                                        <h5 className="gallery-title">{image.title}</h5>
                                        <i className="fas fa-search-plus gallery-icon"></i>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>
            </Container>

            <Modal show={showModal} onHide={closeModal} centered size="lg">
                <Modal.Body className="p-0">
                    {selectedImage && (
                        <div className="modal-image-container">
                            <img 
                                src={selectedImage.src} 
                                alt={selectedImage.title}
                                className="modal-image"
                            />
                            <button 
                                className="modal-close"
                                onClick={closeModal}
                            >
                                <i className="fas fa-times"></i>
                            </button>
                            <div className="modal-info">
                                <span className="modal-category">{selectedImage.category}</span>
                                <h5 className="modal-title">{selectedImage.title}</h5>
                            </div>
                        </div>
                    )}
                </Modal.Body>
            </Modal>
        </section>
    );
};

export default Gallery;